/**
 * WrapLayout: /video-renewal 최상위 CSS 래퍼.
 *
 * v1 원본: RenewalComponents/WrapHOC/index.js (HOC → React.Component)
 * v2 변환: 일반 컴포넌트 (children 래핑)
 *
 * roomStatus, 사이드바, 자막 등 상태에 따라 최상위 <div>의 className을 동적으로 결정.
 * v1에서는 SETUP 상태에서만 notosans_font를 제외하고 나머지에선 항상 포함.
 */
import React from 'react';
import { useAppSelector } from '@/store/hooks';
import { isRecorderMode } from '@/utils/recorderMode';

interface WrapLayoutProps {
  children: React.ReactNode;
}

const WrapLayout: React.FC<WrapLayoutProps> = ({ children }) => {
  const roomStatus = useAppSelector((s) => s.ui.roomStatus);
  const openSideBar = useAppSelector((s) => s.ui.openSideBar);
  const whiteboard = useAppSelector((s) => s.whiteboard);

  const isSetup = roomStatus === 'SETUP';
  const isCoachMarkActive =
    whiteboard.isOpen &&
    whiteboard.isSketchMode &&
    whiteboard.isOwner &&
    !whiteboard.isSketchCoachMarkShown;

  const wrapClass = [
    'rtc',
    'rtc_new',
    'rtc_new3',
    'wrap',
    // SETUP에서만 notosans_font 제외 (v1 WrapHOC 원본 동작)
    'notosans_font',
    // 사이드바 열림 — v1 CSS: .chat_on .content { width: calc(100% - 340px) }
    // openSideBar && 'chat_on',
    // 스케치 코치마크 활성화 시
    isCoachMarkActive && 'rtc_coachMark',
    // recorder(Jibri) 모드 — 헤더/푸터 제거에 맞춰 콘텐츠를 전체화면으로 채운다.
    isRecorderMode() && 'rtc_recorder',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <>
      <div className={wrapClass}>{children}</div>
    </>
  );
};

export default WrapLayout;
